import { Icon, IconsEnum } from 'components/Icons';
import { format } from 'date-fns';
import { useGetDetailIppicaNewsQuery } from 'features/api/ippicaApiSlice';
import { IppicaNewsResponseApi } from 'lib/api/ippica/ippicaNewsResponseApi';
import dynamic from 'next/dynamic';
import { ReactPortal } from '../../../../components/reactPortal';
import styles from './IppicaNewsModal.module.scss';
import { DynamicIppicaNewsModalBody } from './components/ippicaNewsModalBody/IppicaNewsModalBody';

export type IppicaNewsModalProps = {
  item?: IppicaNewsResponseApi;
  isOpen: boolean;
  handleClose: () => void;
};
export const DynamicIppicaNewsModal = dynamic(() =>
  import('features/ippica/components/ippicaNewsModal').then((mod) => mod.IppicaNewsModal)
);
export const IppicaNewsModal = ({ item, isOpen, handleClose }: IppicaNewsModalProps) => {
  const {
    data: detailedIppicaNews,
    isLoading,
    isFetching,
  } = useGetDetailIppicaNewsQuery(item!.id, {
    skip: !item,
  });

  if (!isOpen) return null;

  return (
    <ReactPortal wrapperId="ippicaNewsModal">
      <div className={styles.overlay}>
        <dialog className={`${styles.modal} ${styles['ippica-news-modal']}`}>
          <div className={`${styles.container} ${styles['header-ippica-news-modal']}`}>
            {item?.date ? (
              <span className={styles.labelHours}>
                {`${format(new Date(item.date), 'MM:ss')}`}
                {item.descrizioneRiunione && <span className={styles.label}> - {item?.descrizioneRiunione}</span>}
              </span>
            ) : (
              <span className={styles.label}>{item?.descrizioneRiunione}</span>
            )}
            <button type="button" className={styles.button} onClick={() => handleClose()}>
              <Icon iconId={IconsEnum.CLOSE} className={styles.icon} color="var(--color-on-bg-primary)" />
            </button>
          </div>

          <DynamicIppicaNewsModalBody
            title={item?.title}
            content={detailedIppicaNews?.description}
            handleClose={handleClose}
            isLoading={isLoading || isFetching}
          />
        </dialog>
      </div>
    </ReactPortal>
  );
};
